import { Box } from '@mui/material'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Loading from 'components/loading'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import { useAuthentications } from 'contexts/authentications'
import { useState } from 'react'
import AuthenticationTables from './authentication-tables'
import { useStyles } from './styles'

const Authentications = () => {
  const [type, setType] = useState<string>('todos')

  const classes = useStyles()

  const { isLoading } = useAuthentications()

  if (isLoading) {
    return (
      <Wrapper>
        <Box className={classes.root}>
          <Loading />
        </Box>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title text='Autenticações' />
        {/* <AuthenticationsHeader
          filterValue={type}
          handleClearFilter={() => setType('todos')}
          onChangeFilter={(value: string) => setType(value)}
        /> */}
      </Header>

      <Page>
        <Box className={classes.root}>
          <AuthenticationTables />
        </Box>
      </Page>
    </Wrapper>
  )
}

export default Authentications
